import { ref } from 'vue'
import { defineStore } from 'pinia'
import type { CmsPosBootstrapResponse } from '@nsftx/seven-client-retail-vue-sgp'

export const useCmsConfigStore = defineStore('cmsConfigStore', () => {
  const cmsConfig = ref<CmsPosBootstrapResponse | null>(null)

  const setCmsConfig = (config: CmsPosBootstrapResponse) => {
    cmsConfig.value = config
  }

  return {
    cmsConfig,
    setCmsConfig,
  }
})
